var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"fileSelector",attrs:{"accept":".kml,.kmz","type":"file"},on:{"input":_vm.onFileSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }